import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Sensor } from '@/types';

interface SensorDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sensor: Sensor | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function SensorDeleteDialog({
  open,
  onOpenChange,
  sensor,
  onConfirm,
  isLoading = false,
}: SensorDeleteDialogProps) {
  if (!sensor) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar sensor?</AlertDialogTitle>
          <AlertDialogDescription>
            Estás a punto de eliminar el sensor <strong>"{sensor.name}"</strong>.
            Esta acción no se puede deshacer y se perderán todos los datos históricos
            asociados a este sensor.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isLoading}
          >
            {isLoading ? 'Eliminando...' : 'Eliminar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
